<!--getAll-->
<div class="container">

  <div class="header">
    <h1>welcome To Your University !</h1>
  </div>

  <div class="dashboard">

    <div class="projects-status">
      <button style="width: 150px;" type="button" class="btn btn-primary">
        <span class="badge bg-secondary">{{nFiliere}}</span> &nbsp; Departments
      </button >&nbsp; &nbsp; &nbsp; &nbsp;
      <button style="width: 150px;" type="button" class="btn btn-primary">
        <span class="badge bg-secondary">{{nEnseignant}}</span> &nbsp; Teachers
      </button >&nbsp; &nbsp; &nbsp; &nbsp;
      <button style="width: 150px;" type="button" class="btn btn-primary">
        <span class="badge bg-secondary">{{nClubs}} </span> &nbsp; Clubs
      </button>&nbsp; &nbsp; &nbsp; &nbsp;
      <button style="width: 160px;" type="button" class="btn btn-primary">
        <span class="badge bg-secondary">{{nSalle}} </span> &nbsp; SChoolrooms
      </button>
      <button style="width: 160px;" type="button" class="btn btn-primary">
        <span class="badge bg-secondary">{{nMatiere}} </span> &nbsp; MATTERS
      </button>
    </div>

    <br>
    <br>

    <div class="a-box">
      <div class="img-container">
        <div class="img-inner">
          <div class="inner-skew">
            <img src="../../../assets/images/filiere.jpeg" />
          </div>
        </div>
      </div>
      <div class="text-container">
        <h3><a href="/home/filiere">DEPARTMENTS</a></h3>
      </div>
    </div>

    <div class="a-box">
      <div class="img-container">
        <div class="img-inner">
          <div class="inner-skew">
            <img src="../../../assets/images/teachers.jpeg" />
          </div>
        </div>
      </div>
      <div class="text-container">
        <h3><a href="/home/table-enseignant">TEACHERS</a></h3>
      </div>
    </div>

    <div class="a-box">
      <div class="img-container">
        <div class="img-inner">
          <div class="inner-skew">
            <img src="../../../assets/images/clubs.jpeg" />
          </div>
        </div>
      </div>
      <div class="text-container">
        <h3><a href="/home/table-club">CLUBS</a></h3>
      </div>
    </div>
    <br>
    <br>
    <div class="a-box">
      <div class="img-container">
        <div class="img-inner">
          <div class="inner-skew">
            <img src="../../../assets/images/salle-de-classe.jpg" />
          </div>
        </div>
      </div>
      <div class="text-container">
        <h3><a href="/home/salle">SCHOOLROOMS</a></h3>
      </div>
    </div>
    <div class="a-box">
      <div class="img-container">
        <div class="img-inner">
          <div class="inner-skew">
            <img src="../../../assets/images/matiere.jpg" />
          </div>
        </div>
      </div>
      <div class="text-container">
        <h3><a href="/home/matiere">MATTERS</a></h3>
      </div>
    </div>
  </div>
</div>
